<div class="proceed-group">
  <div class="proceed-label">
    {{ proceedList.name }}
    @if (!readOnly) {
      <button class="add-button" (click)="addProceed()">
        <mat-icon>add</mat-icon>
      </button>
    }
    @if (!readOnly) {
      <button class="delete-button" (click)="deleteRecipient()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
  <table
    [dataSource]="proceedList.proceeds"
    mat-table
    [class]="{ readOnly: readOnly }">
    <ng-container matColumnDef="proceed_type">
      <th mat-header-cell *matHeaderCellDef="">Proceed Type</th>
      <td mat-cell *matCellDef="let proceed">
        <select
          [disabled]="readOnly"
          (keyup)="proceedChanged()"
          [(ngModel)]="proceed.disposition_proceed_type_id">
          <option [value]="null">&mdash;</option>
          @for (
            proceedType of dispositionsService.dispositionProceedTypes$
            | async
            ; track
            proceedType) {
            <option
              [value]="proceedType.id">
              {{ proceedType.name }}
            </option>
          }
        </select>
      </td>
    </ng-container>
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef="">Amount</th>
      <td mat-cell *matCellDef="let proceed">
        @if (!readOnly) {
          <input
            type="number"
            [(ngModel)]="proceed.amount"
            (keyup)="proceedChanged()" />
        }
        <ng-container
          *ngTemplateOutlet="
            readOnly ? valueSpan : nothing;
            context: {
              value: (proceed.amount | currency: 'USD':'symbol':'1.0-0')
            }
          ">
      </ng-container>
    </td>
  </ng-container>
  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let proceed">
      @if (!readOnly) {
        <button
          class="delete-button"
          (click)="deleteProceed(proceed.id)">
          <mat-icon>close</mat-icon>
        </button>
      }
    </td>
  </ng-container>
  <tr
    mat-header-row
  *matHeaderRowDef="['proceed_type', 'amount', 'action']"></tr>
  <tr
    mat-row
      *matRowDef="
        let proceeds;
        columns: ['proceed_type', 'amount', 'action']
      "></tr>
</table>
</div>
<ng-template let-value="value" #valueSpan>
  @if (value?.length) {
    <span class="value">{{ value }}</span>
  } @else {
    <span class="value">&mdash;</span>
  }
</ng-template>
<ng-template #nothing></ng-template>
